export const STATUS_FILTER_DESCRIPTORS = [
  { value: "early", label: "Early" },
  { value: "on_time", label: "On Time" },
  { value: "late_arrival", label: "Late Arrival" },
  { value: "no_data", label: "No Data" },
  { value: "no_show", label: "No Show" },
  { value: "on_site", label: "On Site" },
  { value: "supervisor", label: "Supervisor" },
  { value: "admin", label: "Admin" },
  { value: "replacement", label: "Replacement" },
  { value: "unscheduled", label: "Unscheduled" },
] as const;

export type StatusFilterValue =
  (typeof STATUS_FILTER_DESCRIPTORS)[number]["value"];

export const VALID_STATUS_FILTERS = new Set<StatusFilterValue>(
  STATUS_FILTER_DESCRIPTORS.map((d) => d.value)
);
